export enum Product {
    BasePlatform = 'BasePlatform',
    Wellness = 'Wellness',
    WorkplacePassport = 'WorkplacePassport',
    TransformDPP = 'TransformDPP',
    TransformIBC = 'TransformIBC',
    TransformCVD = 'TransformCVD',
    Navigate = 'Navigate'
}
